import { VehicleEmailModel } from "@project-management-system/shared-models";
import { CommonAxiosService } from "packages/libs/shared-services/src/common-axios-service-prs";

export class EmailService extends CommonAxiosService {
    private dcController = '/vehicle_req';
    
    async sendVehicleMail(req: VehicleEmailModel) {
        return await this.axiosPostCall(this.dcController + '/sendVehicleMail', req)
    }
    
}
